module.exports = __webpack_public_path__ + "static/img/Headline@2x.0186039.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sodastream/Headline@2x.png
// module id = lrcp
// module chunks = 0